import axios, { CancelTokenSource } from 'axios';

const cancelTokenSources: Record<string, CancelTokenSource> = {};

export const createCancelToken = (key: string) => {
    cancelTokenSources[key]?.cancel();
    const cancelTokenSource = axios.CancelToken.source();
    cancelTokenSources[key] = cancelTokenSource;
    return cancelTokenSource.token;
};
